// extracted by mini-css-extract-plugin
export default {"InteractiveColumnCell":"HP9oPkjMUbmK3buyIwclhQ=="};